export default __webpack_public_path__ + "static/media/Phone.e2a21ce2.svg";